export default "__VITE_ASSET__DbuntY3x__"